import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Link } from '../../../design-system';
import { FOOTER_LINKS_CONFIG, FooterLink } from '../constants/footerLinks';
import { NAV_PRODUCT } from '../constants/landingText';
import { handleProductClick } from './handlers/footerHandlers';

const FooterNavLinks: React.FC = () => {
  const navigate = useNavigate();

  const links: FooterLink[] = FOOTER_LINKS_CONFIG.map((config) => {
    if (config.title === NAV_PRODUCT) {
      return { ...config, onClick: handleProductClick };
    }
    if (config.url === '/pricing/') {
      return { ...config, onClick: () => navigate('/pricing/') };
    }
    if (config.url === '/about/') {
      return { ...config, onClick: () => navigate('/about/') };
    }
    return config;
  });

  return (
    <Box
      component="nav"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: '0.5rem', md: '1rem' },
        alignItems: 'center',
      }}
      aria-label="Footer navigation"
    >
      {links.map((link) => (
        <Link
          key={link.title}
          variant="navigation"
          component={link.onClick ? 'button' : 'a'}
          href={link.url}
          onClick={link.onClick}
          target={link.target}
          rel={link.target === '_blank' ? 'noopener noreferrer' : undefined}
        >
          {link.title}
        </Link>
      ))}
    </Box>
  );
};

export default FooterNavLinks;
